export default "__VITE_ASSET__Ciyu3YU3__"